import { fetchWithTimeout } from './fetchWithTimeout';
import { User } from './user';

export type Car = {
    carId?: string;
    createBy?: string;
    createDate?: Date;
    updateBy?: string;
    updateDate?: Date;
    select?: (keyof Car)[];
    order?: { [P in keyof Car]: 'ASC' | 'DESC' | 'asc' | 'desc' | 1 | -1 };
    loadEagerRelations?: boolean;
    users?: User[];
};

type CreateRequestData = Car & {};

type CreateResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Car;
};

function create(data: CreateRequestData) {
    return fetchWithTimeout('car/create', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: CreateResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type CreateBulkResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Car[];
};

function createBulk(data: CreateRequestData[]) {
    return fetchWithTimeout('car/createBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: CreateBulkResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type GetRequestData = Car & {
    select?: (keyof Car)[];
    loadEagerRelations?: boolean;
    relations?: {
        [key in keyof Pick<Car, 'users'>]?: boolean;
    };
};

type GetResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Car[];
};

function get(data: GetRequestData) {
    return fetchWithTimeout('car/get', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: GetResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type UpdateRequestData = Car & { carId: string };

type UpdateResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Car;
};

function update(data: UpdateRequestData) {
    return fetchWithTimeout('car/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: UpdateResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type UpdateBulkResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: Car[];
};

function updateBulk(data: UpdateRequestData[]) {
    return fetchWithTimeout('car/updateBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: UpdateBulkResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type RemoveRequestData = Car & { carId: string };

type RemoveResponseData = {
    statusCode: number;
    message: string;
    success: boolean;
    data?: {};
};

function remove(data: RemoveRequestData) {
    return fetchWithTimeout('car/remove', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: RemoveResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

function removeBulk(data: RemoveRequestData[]) {
    return fetchWithTimeout('car/removeBulk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: RemoveResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

export default { create, createBulk, get, update, updateBulk, remove, removeBulk };
